import { render, staticRenderFns } from "./UserTypeCard.vue?vue&type=template&id=452adabe&scoped=true&"
import script from "./UserTypeCard.vue?vue&type=script&lang=js&"
export * from "./UserTypeCard.vue?vue&type=script&lang=js&"
import style0 from "./UserTypeCard.vue?vue&type=style&index=0&id=452adabe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452adabe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
